export const WEGLOT_APPLY_CLASS = "weglot-apply";
export const WEGLOT_SKIP_CLASS = "weglot-skip";
export const WEGLOT_SCRIPT_ID = "weglot-source";
